import { createContext, useContext, useEffect, useRef, useState } from "react";

import { USE_DUMMY, DUMMY_MISSION_LOGS_INFO } from "lib/consts/testing";

export const MissionControlContext = createContext();
MissionControlContext.displayName = "MissionControl";
export const useMissionControl = () => useContext(MissionControlContext);

const MissionControlProvider = ({ children }) => {
    const [showMissionsInControl, setShowMissionsInControl] = useState(false);
    const [showBehaviourInControl, setShowBehaviourInControl] = useState(false);

    // Persists across ControlPage remounts (e.g. navigating to/from settings)
    const [showViewMissionSubpage, setShowViewMissionSubpage] = useState(false);
    const [selectedMissionId, setSelectedMissionId] = useState(null);
    // Tracks which running mission we already auto-opened so remounts don't force-reopen
    // after the user dismissed the subpage, and so route changes don't lose "already opened".
    const lastAutoOpenedRunningMissionIdRef = useRef(null);

    const [missions, setMissions] = useState(USE_DUMMY ? DUMMY_MISSION_LOGS_INFO : []);
    const [currentMission, setCurrentMission] = useState(null);
    const [currentMissionState, setMissionState] = useState(null);

    // Mission recording state - used to determine if actions should be recorded vs executed
    const [missionRecording, setMissionRecording] = useState(false);
    const [missionRecordCallback, setMissionRecordCallback] = useState(null);

    useEffect(() => {
        if (!currentMissionState) return;
    });

    return (
        <MissionControlContext.Provider
            value={{
                showMissionsInControl,
                setShowMissionsInControl,
                showBehaviourInControl,
                setShowBehaviourInControl,
                showViewMissionSubpage,
                setShowViewMissionSubpage,
                selectedMissionId,
                setSelectedMissionId,
                lastAutoOpenedRunningMissionIdRef,
                missions,
                setMissions,
                currentMission,
                setCurrentMission,
                currentMissionState,
                setMissionState,
                missionRecording,
                setMissionRecording,
                missionRecordCallback,
                setMissionRecordCallback,
            }}
        >
            {children}
        </MissionControlContext.Provider>
    );
};

export default MissionControlProvider;
